<template>
  <StepperHeader :current="2" />
  <RegisterLayout>
    <template #description>
      <h2>¡Un servicio a tu medida!</h2>
      <p>
        Recuerda que estos accesos te permitirán iniciar sesión y por tu seguridad debes seguir los
        parámetros para crear una contraseña segura.
      </p>

      <section class="drawing">
        <img src="@/app/register/assets/rocket.png" height="400" alt="rocket" />
      </section>
    </template>

    <template #form>
      <FormCard title="Cuéntanos un poco más sobre tu empresa" hide-img>
        <business-form />
      </FormCard>
    </template>
  </RegisterLayout>
</template>

<script>
import { defineComponent } from "vue";

import BusinessForm from "../forms/BusinessForm.vue";
import StepperHeader from "../header/StepperHeader.vue";
import RegisterLayout from "../layout/RegisterLayout.vue";
import FormCard from "@/app/auth/components/atoms/FormCard.vue";

export default defineComponent({
  components: {
    BusinessForm,
    StepperHeader,
    RegisterLayout,
    FormCard,
  },
  computed: {
    name() {
      return this.$store.getters["getTemporalUserName"];
    },
  },
  created() {
    this.validateToken();
    this.$store.dispatch("setRegistrationProgress", 1);
  },
  methods: {
    async validateToken() {
      try {
        const token = this.$route.params.token;
        await this.$store.dispatch("validateRegisterTemporalToken", token);
      } catch {
        this.$router.push("/register");
      }
    },
  },
});
</script>

<style lang="sass" scoped>


.container
  width: 35%
  margin-top: 40px
  margin-left: 11%

.drawing
  text-align: center

.container__info
  margin: 0 auto
  margin-top: 70px
  text-align: center
  margin-bottom: 50px

.name
  font-weight: 600
  font-size: 30px
  line-height: 2

.subtitle
  font-size: 20px

.flex
  display: flex
  justify-content: space-between
</style>
